import { render, staticRenderFns } from "./classroom-checkbox-control.vue?vue&type=template&id=247b76c2&"
import script from "./classroom-checkbox-control.vue?vue&type=script&lang=js&"
export * from "./classroom-checkbox-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports